// Mock data for MERX CONSULTORIA Landing Page

export const companyInfo = {
  name: "MERX CONSULTORIA",
  tagline: "Expertos en Limpieza Profesional",
  foundedDate: "2 de Agosto, 2023",
  yearsOfExperience: 2,
  email: "contacto@merxconsultoria.com",
  address: "Calle Chichen-Itza No. 4955, int. 10 C, col. Mirador del Sol. Zapopan, Jalisco, México",
  phone: "333 816 4603",
  mission: "Brindar servicios de limpieza excelentes que superen constantemente nuestras expectativas y las de nuestros clientes. Nos comprometemos a mantener entornos impecables y saludables mediante procesos eficientes y personal altamente capacitado.",
  vision: "Ser la empresa referente y líder en la industria de la limpieza y mantenimiento de espacios, reconocidos por nuestra innovación, compromiso con la sostenibilidad y por transformar entornos en espacios saludables y productivos."
};

export const services = [
  {
    id: 1,
    title: "Limpieza General de Inmuebles",
    description: "Limpieza integral de todo tipo de propiedades. Mantenemos espacios de trabajo óptimos en oficinas corporativas y garantizamos hogares impecables y desinfectados.",
    icon: "Building2",
    features: [
      "Oficinas Corporativas",
      "Residencias Privadas", 
      "Edificios Comerciales"
    ]
  },
  {
    id: 2,
    title: "Limpieza Profunda Post-Construcción",
    description: "Eliminación de escombros, polvo y residuos, dejando las instalaciones nuevas listas para su uso inmediato.",
    icon: "HardHat",
    features: [
      "Remoción de escombros",
      "Eliminación de polvo fino",
      "Preparación para ocupación"
    ]
  },
  {
    id: 3,
    title: "Desinfección de Áreas Críticas",
    description: "Desinfección exhaustiva con productos de grado profesional para garantizar la máxima asepsia en espacios sensibles.",
    icon: "Shield",
    features: [
      "Productos profesionales",
      "Protocolos certificados",
      "Máxima asepsia"
    ]
  },
  {
    id: 4,
    title: "Limpieza de Cristales y Fachadas",
    description: "Mantenemos una imagen impecable y confiable de sus espacios con productos especializados para una apariencia reluciente.",
    icon: "Sparkles",
    features: [
      "Fachadas impecables",
      "Cristales sin manchas",
      "Imagen profesional"
    ]
  },
  {
    id: 5,
    title: "Limpieza de Ductos",
    description: "Mejoramos la calidad del aire y reducimos contaminantes, contribuyendo a la productividad y bienestar de todos.",
    icon: "Wind",
    features: [
      "Mejor calidad del aire",
      "Reducción de contaminantes",
      "Mayor productividad"
    ]
  },
  {
    id: 6,
    title: "Limpieza para Eventos Especiales",
    description: "Paquetes personalizados para antes, durante y después de eventos corporativos o sociales, proyectando excelencia.",
    icon: "PartyPopper",
    features: [
      "Eventos corporativos",
      "Eventos sociales",
      "Servicio integral"
    ]
  }
];

export const methodology = [
  {
    step: 1,
    title: "Evaluación y Diagnóstico Personalizado",
    description: "Evaluación detallada del espacio, flujo de personas, superficies y necesidades específicas del cliente para crear un plan 100% personalizado.",
    image: "https://customer-assets.emergentagent.com/job_merx-landing/artifacts/pize8b7u_Metodolog%C3%ADa%20Paso%201%20Evaluaci%C3%B3n.webp"
  },
  {
    step: 2,
    title: "Planeación Estratégica y Protocolos",
    description: "Creamos un plan a la medida con protocolos estandarizados y productos especializados efectivos y seguros.",
    image: "https://customer-assets.emergentagent.com/job_merx-landing/artifacts/7zgzzzy5_Metodolog%C3%ADa%20Paso%202.%20Planificaci%C3%B3n.webp"
  },
  {
    step: 3,
    title: "Implementación con Tecnología",
    description: "Uso de productos y equipos profesionales, con capacitación continua en las últimas técnicas de limpieza.",
    image: "https://customer-assets.emergentagent.com/job_merx-landing/artifacts/gx9lzjla_Metodolog%C3%ADa%20Paso%203%20Implementaci%C3%B3n.webp"
  },
  {
    step: 4,
    title: "Supervisión y Control de Calidad",
    description: "Supervisión constante para garantizar que las tareas se ejecuten perfectamente y los ambientes queden impecables.",
    image: "https://customer-assets.emergentagent.com/job_merx-landing/artifacts/athq8apf_Metodolog%C3%ADa%20Paso%204%20Supervisi%C3%B3n.webp"
  },
  {
    step: 5,
    title: "Mantenimiento y Seguimiento",
    description: "Establecemos un plan de seguimiento para mantener los ambientes higiénicos y saludables a largo plazo.",
    image: "https://customer-assets.emergentagent.com/job_merx-landing/artifacts/yd4d0wsd_Metodolog%C3%ADa%20Paso%205%20Mantenimiento.webp"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos Méndez",
    position: "Director General",
    company: "Grupo Empresarial del Bajío",
    comment: "MERX transformó completamente nuestras oficinas. Su enfoque científico y profesional es evidente en cada detalle. Nuestros empleados han notado la diferencia.",
    rating: 5
  },
  {
    id: 2,
    name: "Ana Patricia Rodríguez",
    position: "Gerente de Operaciones",
    company: "Constructora del Pacífico",
    comment: "El servicio post-construcción fue impecable. Dejaron nuestros proyectos listos para entrega en tiempo récord. Altamente recomendados.",
    rating: 5
  },
  {
    id: 3,
    name: "Roberto Sánchez",
    position: "Administrador de Edificios",
    company: "Inmobiliaria Guadalajara",
    comment: "Llevamos más de un año trabajando con MERX y su consistencia es extraordinaria. Son verdaderos aliados estratégicos para mantener la imagen de nuestros edificios.",
    rating: 5
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "La ciencia detrás de un ambiente impecable: así trabajamos en Merx Consultoría",
    excerpt: "En Merx, hemos elevado la limpieza a la categoría de ciencia. Para nosotros, un espacio verdaderamente higiénico no se logra solo con esfuerzo, sino con el rigor de protocolos estandarizados...",
    content: "En Merx, hemos elevado la limpieza a la categoría de ciencia. Para nosotros, un espacio verdaderamente higiénico no se logra solo con esfuerzo, sino con el rigor de protocolos estandarizados y el uso de productos especializados, seleccionados rigurosamente por su eficacia y seguridad. Nuestro equipo, además, se capacita continuamente en las últimas técnicas para abordar cada tipo de superficie y contaminación. Este enfoque científico nos permite garantizar no solo una apariencia limpia, sino un ambiente verdaderamente higiénico y saludable en cada inmueble que intervenimos. Nuestro compromiso es con la limpieza profunda, industrial y de mantenimiento, utilizando productos que garantizan un ambiente fresco y saludable y asegurando que cada rincón refleje limpieza y bienestar.",
    date: "15 de Diciembre, 2024",
    category: "Ciencia",
    readTime: "5 min",
    image: "https://customer-assets.emergentagent.com/job_merx-landing/artifacts/dmi9na02_Noticia%201.webp"
  },
  {
    id: 2,
    title: "¿Limpieza a la medida? Descubre la metodología personalizada de Merx",
    excerpt: "Entendemos que cada espacio es único. Por eso, nos distinguimos por desarrollar planes de limpieza 100% personalizados tras una evaluación exhaustiva de cada inmueble...",
    content: "Entendemos que cada espacio es único. Por eso, nos distinguimos por desarrollar planes de limpieza 100% personalizados tras una evaluación exhaustiva de cada inmueble en el que trabajamos. Nuestro enfoque se centra en la precisión y la eficacia comprobada al considerar el flujo de personas, los materiales de las superficies y las necesidades específicas de cada cliente y espacio. Esta metodología a medida nos permite optimizar recursos y garantizar una limpieza profunda y eficiente, adaptada precisamente a sus requerimientos. Nuestra promesa es que cada espacio no solo se vea limpio, sino que esté verdaderamente revitalizado, demostrando así nuestro compromiso con la excelencia y la satisfacción del cliente.",
    date: "5 de Diciembre, 2024",
    category: "Metodología",
    readTime: "6 min",
    image: "https://customer-assets.emergentagent.com/job_merx-landing/artifacts/j0e5z962_Noticia%202.webp"
  },
  {
    id: 3,
    title: "Más que limpieza, Merx, el mejor aliado para tu imagen profesional",
    excerpt: "La limpieza de sus instalaciones es un reflejo directo de su profesionalismo. En Merx, somos su aliado estratégico para proyectar una imagen impecable y confiable...",
    content: "La limpieza de sus instalaciones es un reflejo directo de su profesionalismo. En Merx, somos su aliado estratégico para proyectar una imagen impecable y confiable a través de nuestros servicios de limpieza de excelencia. Nuestro compromiso es asegurar que cada rincón refleje limpieza y bienestar, ya que creemos que un entorno limpio mejora la calidad de vida y la productividad. Invertir en una limpieza profesional no solo mejora el bienestar de sus empleados y clientes, sino que también fortalece la percepción de su marca. En Merx, valoramos y procuramos espacios pulcros, y le brindamos un servicio profesional que le ayuda a fortalecer el prestigio y la funcionalidad de su negocio.",
    date: "25 de Noviembre, 2024",
    category: "Imagen Corporativa",
    readTime: "5 min",
    image: "https://customer-assets.emergentagent.com/job_merx-landing/artifacts/5lmgiv3m_Noticia%203.webp"
  }
];

export const faqs = [
  {
    id: 1,
    question: "¿Qué diferencia a MERX de otras empresas de limpieza?",
    answer: "Nuestro enfoque científico y metodología personalizada nos distingue. No solo limpiamos, transformamos espacios aplicando protocolos estandarizados y productos especializados, garantizando ambientes verdaderamente higiénicos y saludables."
  },
  {
    id: 2,
    question: "¿Qué tipo de productos utilizan?",
    answer: "Utilizamos productos de grado profesional, efectivos y seguros. Nuestros productos especializados están diseñados para cada tipo de superficie y necesidad específica, garantizando resultados impecables sin comprometer la seguridad."
  },
  {
    id: 3,
    question: "¿Ofrecen servicios de mantenimiento recurrente?",
    answer: "Sí, ofrecemos planes de mantenimiento personalizados con seguimiento continuo. Establecemos calendarios adaptados a sus necesidades para mantener sus espacios impecables todo el tiempo."
  },
  {
    id: 4,
    question: "¿Trabajan con edificios comerciales grandes?",
    answer: "Absolutamente. Contamos con la capacidad, equipo y personal capacitado para atender desde oficinas pequeñas hasta grandes complejos comerciales e industriales."
  },
  {
    id: 5,
    question: "¿Cómo solicito una cotización?",
    answer: "Puede contactarnos a través del formulario en esta página, por correo electrónico a contacto@merxconsultoria.com, o visitarnos en nuestras oficinas. Realizaremos una evaluación personalizada sin compromiso."
  },
  {
    id: 6,
    question: "¿Tienen certificaciones?",
    answer: "Nuestro personal está en capacitación continua en las últimas técnicas y protocolos de limpieza profesional. Nos comprometemos con la excelencia y la mejora constante."
  }
];

export const stats = [
  {
    value: "2+",
    label: "Años de Experiencia"
  },
  {
    value: "150+",
    label: "Clientes Satisfechos"
  },
  {
    value: "3000+",
    label: "Espacios Transformados"
  },
  {
    value: "100%",
    label: "Compromiso con Calidad"
  }
];

export const successCases = [
  {
    id: 1,
    title: "Transformación Corporativa - Torre Empresarial",
    client: "Grupo Financiero del Occidente",
    description: "Limpieza integral y mantenimiento continuo de 12 pisos de oficinas corporativas, mejorando significativamente el ambiente laboral.",
    results: [
      "Reducción del 40% en quejas de calidad del aire",
      "Incremento en satisfacción de empleados",
      "Imagen corporativa renovada"
    ],
    industry: "Financiero"
  },
  {
    id: 2,
    title: "Proyecto Industrial - Planta de Manufactura",
    client: "Industrias del Bajío S.A.",
    description: "Limpieza profunda post-construcción y desinfección especializada de áreas críticas en nueva planta de producción de 5,000 m². Implementamos protocolos industriales avanzados garantizando el cumplimiento de normativas sanitarias y de seguridad para el arranque de operaciones.",
    results: [
      "Entrega a tiempo para inicio de operaciones",
      "Cumplimiento de normativas de higiene",
      "Certificación de calidad aprobada"
    ],
    industry: "Industrial"
  },
  {
    id: 3,
    title: "Mantenimiento Continuo - Centro Comercial",
    client: "Plaza del Sol",
    description: "Servicio integral de limpieza y mantenimiento para centro comercial con más de 100 locales comerciales.",
    results: [
      "Mejora en percepción de visitantes",
      "Reducción de costos operativos",
      "Contrato renovado por 3 años"
    ],
    industry: "Retail"
  }
];

export const valuePropositions = [
  {
    icon: "Microscope",
    title: "Enfoque Científico",
    description: "Elevamos la limpieza a la categoría de ciencia con protocolos estandarizados y productos especializados."
  },
  {
    icon: "Users",
    title: "Personal Capacitado",
    description: "Equipo altamente entrenado con capacitación continua en las últimas técnicas profesionales."
  },
  {
    icon: "ClipboardCheck",
    title: "Planes Personalizados",
    description: "Cada espacio es único. Creamos soluciones 100% adaptadas a sus necesidades específicas."
  },
  {
    icon: "Handshake",
    title: "Aliado Estratégico",
    description: "Más que un proveedor, somos su socio en bienestar, productividad e imagen corporativa."
  },
  {
    icon: "Leaf",
    title: "Compromiso Sustentable",
    description: "Innovación y responsabilidad ambiental en cada uno de nuestros procesos."
  },
  {
    icon: "Award",
    title: "Excelencia Garantizada",
    description: "Superamos expectativas constantemente con supervisión y control de calidad riguroso."
  }
];
